import { QUERY_KEYS } from 'api/query-keys';
import { CreateShiftRequestDto } from 'api/services/shift/shift-service.dto';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { sharedShiftService } from 'api/services';
import { useSiteDetection } from 'shared/hooks';

type ShiftMutationOptions = UseMutationOptions<string[], Error, CreateShiftRequestDto>;

export const useCreateShift = () => {
  const queryClient = useQueryClient();
  const { site } = useSiteDetection();

  const mutationFn = async (shift: CreateShiftRequestDto) =>
    await sharedShiftService.createShift(site, shift);
  const options: ShiftMutationOptions = {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shifts());
    },
  };

  return useMutation(mutationFn, options);
};
